// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.job_jobForm__sLDmk {
  color: #aab5b7;
  margin-bottom: 0.5em;
}
.job_jobForm__sLDmk h3 {
  color: #fff;
  text-align: center;
}

.job_jobFormFormControl__i0jn7,
.job_jobFormFormSelect__Bd6l\\+ {
  width: 100%;
  border-radius: 1.5em;
  border: 1px solid rgba(255, 255, 255, 0.5);
  transition: border-color 0.3s ease;
}

.job_jobFormFormControl__i0jn7:focus,
.job_jobFormFormSelect__Bd6l\\+:focus {
  outline: none;
  border-color: #aab5b7;
}

.job_jobFormFormControl__i0jn7::placeholder {
  color: rgba(255, 255, 255, 0.7);
}

.job_jobFormTextDanger__1Prxx {
  color: #aab5b7 !important;
}

.job_jobFormFormSubmit__wAw6G {
  padding: 0.5em 4em;
  color: #444;
  background-color: #fff !important;
  border-color: rgb(79, 81, 79) !important;
  border-radius: 2em;
  margin: 2px;
  width: 100%;
}

.job_jobFormFormSection__naMFX {
  display: flex;
  flex-direction: column;
}

@media (max-width: 768px) {
  .job_jobFormFormSection__naMFX {
    margin: 0 auto;
  }
}
`, "",{"version":3,"sources":["webpack://./src/COMPONENTS/FORM/JOB_APPLICATION/job.module.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,oBAAoB;EACpB,0CAA0C;EAC1C,kCAAkC;AACpC;;AAEA;;EAEE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iCAAiC;EACjC,wCAAwC;EACxC,kBAAkB;EAClB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE;IACE,cAAc;EAChB;AACF","sourcesContent":[".jobForm {\n  color: #aab5b7;\n  margin-bottom: 0.5em;\n}\n.jobForm h3 {\n  color: #fff;\n  text-align: center;\n}\n\n.jobFormFormControl,\n.jobFormFormSelect {\n  width: 100%;\n  border-radius: 1.5em;\n  border: 1px solid rgba(255, 255, 255, 0.5);\n  transition: border-color 0.3s ease;\n}\n\n.jobFormFormControl:focus,\n.jobFormFormSelect:focus {\n  outline: none;\n  border-color: #aab5b7;\n}\n\n.jobFormFormControl::placeholder {\n  color: rgba(255, 255, 255, 0.7);\n}\n\n.jobFormTextDanger {\n  color: #aab5b7 !important;\n}\n\n.jobFormFormSubmit {\n  padding: 0.5em 4em;\n  color: #444;\n  background-color: #fff !important;\n  border-color: rgb(79, 81, 79) !important;\n  border-radius: 2em;\n  margin: 2px;\n  width: 100%;\n}\n\n.jobFormFormSection {\n  display: flex;\n  flex-direction: column;\n}\n\n@media (max-width: 768px) {\n  .jobFormFormSection {\n    margin: 0 auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"jobForm": `job_jobForm__sLDmk`,
	"jobFormFormControl": `job_jobFormFormControl__i0jn7`,
	"jobFormFormSelect": `job_jobFormFormSelect__Bd6l+`,
	"jobFormTextDanger": `job_jobFormTextDanger__1Prxx`,
	"jobFormFormSubmit": `job_jobFormFormSubmit__wAw6G`,
	"jobFormFormSection": `job_jobFormFormSection__naMFX`
};
export default ___CSS_LOADER_EXPORT___;
